/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnItemsDialog extends _Ext.ItemEditorDialog<ApprovalOutReturnItemsRow> {
        protected getFormKey() { return ApprovalOutReturnItemsForm.formKey; }
        protected getLocalTextPrefix() { return ApprovalOutReturnItemsRow.localTextPrefix; }
        protected getDeletePermission() { return ApprovalOutReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return ApprovalOutReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return ApprovalOutReturnItemsRow.updatePermission; }

        protected form = new ApprovalOutReturnItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public ItemMaster: any;
        public masterId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        // #endregion 

        constructor() {
            super(); 
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            q.hideEditorToolbar(this.form.BOMDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            // **** Assign Values to BOM and Labor Editor ****

            this.form.Pieces.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate
            });

            // **** On Pieces Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate
            });

            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate
            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                var LAmount = 0;
                var Wst = 0;
                for (var k of this.form.LaborDetails.getItems()) {
                    if (k.ProcessName == "Wastage")
                        Wst += k.WstPer;

                    LAmount += k.LabourAmount;
                }
                this.form.UnitLabour.value = LAmount;
                this.form.WstPer.value = Wst;
                this.form.WstWt.value = this.form.Weight.value * Wst;
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });

            
            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate
            });

        }

     
        protected afterLoadEntity() {
            super.afterLoadEntity();
            let vouchertypeid = (this.parentEditor.parentDialog as ApprovalOutReturnDialog).form.VoucherTypeId.value;
            ItemFieldHelper.SalesItemFields(this, vouchertypeid);
            q.showAndDisableField(this.form.UnitRate);
        } 

            // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() {

            //this.form.ProductId.value == undefined ? this.entity.HasBom = false : this.form.HasBom.value = true;
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    //q.showAndDisableField(this.form.Purity);
                    //q.showAndSetRequiredField(this.form.Purity);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);

                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.SieveId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);
                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndDisableField(this.form.StoneCutId);
                        q.showAndDisableField(this.form.StonePolishId);
                        q.showAndDisableField(this.form.StoneSymmetryId);
                        q.showAndDisableField(this.form.StoneFluorescenceId);
                        q.showAndDisableField(this.form.StoneCuletId);
                        q.showAndDisableField(this.form.StoneGirdleId);
                        q.showAndDisableField(this.form.StoneTable);
                        q.showAndDisableField(this.form.StoneDepth);
                        q.showAndDisableField(this.form.CertificateNo);
                        q.showAndDisableField(this.form.Pieces);
                        q.showAndDisableField(this.form.Weight);
                        q.showAndDisableField(this.form.Lab);
                    }

                    //this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.entity.SKU != "0" ? q.showAndEnableField(this.form.Pieces) : q.showAndDisableField(this.form.Pieces);
                q.showAndDisableField(this.form.Weight);
                this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.showAndDisableField(this.form.Line_No);
            }

            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductCode) : q.showAndSetRequiredField(this.form.ProductCode);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductName) : q.showAndSetRequiredField(this.form.ProductName);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductTypeId) : q.showAndSetRequiredField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.UnitRate);


        } 

        getItem() {
            return this.getSaveEntity();
        }
    }
}